import styled from 'styled-components';

const ProductActionsWrapper = styled.div`
    align-self: center;
    display: flex;
    gap: ${({ theme }) => theme.Spacing.spacing2x };
`;

export default ProductActionsWrapper;
